import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  admin: () => import("/app/middleware/admin.ts")
}